import { render, staticRenderFns } from "./AdminAreaBranchDetailTabNewHospitalModal.vue?vue&type=template&id=07cef757&scoped=true&"
import script from "./AdminAreaBranchDetailTabNewHospitalModal.vue?vue&type=script&lang=js&"
export * from "./AdminAreaBranchDetailTabNewHospitalModal.vue?vue&type=script&lang=js&"
import style0 from "./AdminAreaBranchDetailTabNewHospitalModal.vue?vue&type=style&index=0&id=07cef757&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07cef757",
  null
  
)

export default component.exports